"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../styles/palette");

var _Icon = _interopRequireDefault(require("../../atoms/Icon"));

var _icons = require("../../../static/icons/icons");

var _Timeline = _interopRequireDefault(require("../../atoms/Timeline"));

var _style = require("./style");

var ServiceStatus = function ServiceStatus(_ref) {
  var text = _ref.text,
      status = _ref.status,
      code = _ref.code,
      bags = _ref.bags,
      style = _ref.style,
      events = _ref.events,
      trackingDetails = _ref.trackingDetails,
      serviceCanceled = _ref.serviceCanceled,
      openOnLoad = _ref.openOnLoad,
      testId = _ref.testId;

  var _useState = (0, _react.useState)(openOnLoad),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var toggleOpen = function toggleOpen() {
    return setOpen(!open);
  };

  return _react["default"].createElement(_style.ShadowContainer, {
    "data-test-id": testId
  }, _react["default"].createElement(_style.Container, {
    onClick: toggleOpen,
    open: open
  }, _react["default"].createElement(_style.RowsContainer, null, _react["default"].createElement(_style.ServiceBlock, null, _react["default"].createElement(_style.Title, null, text.service), _react["default"].createElement(_style.Detail, {
    "data-test-id": "service-status-code"
  }, code)), _react["default"].createElement(_style.ServiceBlock, null, _react["default"].createElement(_style.Title, null, text.luggage), _react["default"].createElement(_style.Detail, {
    "data-test-id": "service-status-bags"
  }, bags))), _react["default"].createElement(_style.Status, style, status), _react["default"].createElement(_style.Arrow, {
    open: open
  }, _react["default"].createElement(_Icon["default"], {
    icon: _icons.ICONS.TOP,
    size: 14
  }))), _react["default"].createElement(_style.Content, null, _react["default"].createElement(_style.InnerContent, {
    open: open
  }, _react["default"].createElement(_Timeline["default"], {
    events: events,
    serviceCanceled: serviceCanceled
  }), trackingDetails.length > 0 && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_style.TrackingDetailsTitle, null, text.trackingDetails), trackingDetails.map(function (_ref2) {
    var date = _ref2.date,
        event = _ref2.event;
    return _react["default"].createElement(_style.TrackingDetailsEvent, {
      key: "".concat(event).concat(date)
    }, _react["default"].createElement(_style.TrackingDetailsEventDate, null, date), _react["default"].createElement(_style.TrackingDetailsEventName, null, event));
  })))));
};

ServiceStatus.propTypes = {
  status: _propTypes["default"].string.isRequired,
  code: _propTypes["default"].string.isRequired,
  bags: _propTypes["default"].number.isRequired,
  text: _propTypes["default"].shape({
    service: _propTypes["default"].string,
    luggage: _propTypes["default"].string,
    trackingDetails: _propTypes["default"].string
  }),
  style: _propTypes["default"].shape({
    background: _propTypes["default"].string,
    color: _propTypes["default"].string
  }),
  trackingDetails: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    date: _propTypes["default"].string,
    event: _propTypes["default"].string
  })),
  events: _propTypes["default"].arrayOf(_propTypes["default"].object),
  serviceCanceled: _propTypes["default"].bool,
  openOnLoad: _propTypes["default"].bool,
  testId: _propTypes["default"].string
};
ServiceStatus.defaultProps = {
  text: {
    service: 'Service',
    luggage: 'Luggage',
    trackingDetails: 'Tracking details'
  },
  style: {
    background: _palette.palette.darkWhite,
    color: _palette.palette.bobBlack
  },
  trackingDetails: [],
  events: [],
  serviceCanceled: false,
  openOnLoad: false,
  testId: undefined
};
var _default = ServiceStatus;
exports["default"] = _default;